<div class="menu-items flex flex-col mt-8">
  @for (item of navMenuItems; track item) {
    <div class="mb-2">
      <p-button
        styleClass="sidebar-menu-item"
        [text]="!item.isActive"
        [icon]="item.icon"
        (click)="item.action()"
        [label]="item.label">
      </p-button>
    </div>
  }
</div>
<div class="menu-divider mb-2"></div>
<div class="additional-menu-items">
  <div>
    <p-button
      styleClass="sidebar-menu-item"
      [text]="true"
      [icon]="'pi pi-info-circle'"
      [label]="'Community Resources'"
      communityResourcesDialog>
    </p-button>
  </div>
</div>
